import { nbaCatalog } from "./nbaCatalog";
import { nflCatalog } from "./nflCatalog";
import { mlbCatalog } from "./mlbCatalog";

export function getQueryCatalog(sport) {
  if (sport === "nba") return nbaCatalog;
  if (sport === "nfl") return nflCatalog;
  return mlbCatalog;
}
